import React from 'react';

import { TTab } from '@/components/global/Tabs/Tab';

type TProps = {
  text: string;
  idLiferay: string;
  items: TTab[];
  onClick: (tabId: string) => void;
};

export function Options({ text, idLiferay, items, onClick }: TProps) {
  return (
    <form
      className="vitrine-template1__options"
      key={`form-option-${idLiferay}`}
    >
      <span className="vitrine-template1__options-question">
        <strong>{text}</strong>
      </span>
      {items.map(item => (
        <label
          key={item.key}
          htmlFor={item.id}
          className="vitrine-template1__option-label"
        >
          <input
            key={`form-option-.idLiferay}-${item.id}-${item.active}`}
            id={item.id}
            type="radio"
            name="option"
            defaultChecked={item.active}
            onChange={() => onClick(item.id)}
            className="vitrine-template1__option-radio"
          />
          {item.label}
        </label>
      ))}
    </form>
  );
}
